export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  photo: string;
}

export const testimonials: Testimonial[] = [
  {
    quote: 'I finally have a process I can return to instead of starting from scratch every time.',
    name: 'Maria',
    role: 'Dentist in United States',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/1539bc8d-21cf-4b42-8f55-cc01f8fbff3f.jpg',
  },
  {
    quote: 'The workflow maps make complex cases much easier to organize.',
    name: 'James',
    role: 'Dentist in United Kingdom',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f83cced5-c5fa-4719-a8e6-71e842f84bd7.jpg',
  },
  {
    quote: 'I use the checklists to structure how I review my cases.',
    name: 'Andrea',
    role: 'Dentist in Australia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/219bf32e-2df9-4df6-ba5c-e3399a810105.jpg',
  },
  {
    quote: 'It doesn’t feel like another ebook. It feels like a practical workflow system.',
    name: 'Michael',
    role: 'Dentist in United States',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/2e24487a-3ab8-42cd-814e-2481aeebf854.jpg',
  },
  {
    quote: 'Everything is organized around a process instead of being scattered across different resources.',
    name: 'Laura',
    role: 'Dentist in Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/ddd20456-b82d-420d-895a-5a114680b656.jpg',
  },
];
